export default "/images/vendor/flag-icon-css/flags/1x1/tk.svg?e3d850fb9644bf50d89118be561bd46e";